module.exports = __webpack_public_path__ + "static/img/14010013.712a53d3.png";